// extracted by mini-css-extract-plugin
export default {"shell":"profilePage_shell__8JYbq","listningBlock":"profilePage_listningBlock__Fi6E5","gridAndPaginaton":"profilePage_gridAndPaginaton__togPs"};